import whatIsImg from '../../assets/raj/what-is-diabeties.webp';
import typesImg from '../../assets/raj/types-of-diabetes.jpg';
import symptomImg from '../../assets/raj/human-body-hyperglycemia-diabetes-illustration-symptoms-23874.webp';
import preventionImg from '../../assets/raj/prevent-diabeties.jfif';
import treatmentImg from '../../assets/raj/treatmrnt.webp';
import type1Img from '../../assets/raj/insuline.jfif';
import type2Img from '../../assets/raj/type-1-vs-type-2.avif';
import gestationalImg from '../../assets/raj/fourT.jfif';
import faqImg from '../../assets/raj/Dr-Rukiya.webp';

export const fallbackDiabetesBlogs = [
  {
    id: 'diabetes-1',
    slug: 'what-is-diabetes',
    title: 'What Is Diabetes? A Complete Guide To Understanding The Condition',
    excerpt:
      'Diabetes is a disorder, not a disease. It is a metabolic condition with serious health consequences, but one that can often be managed with timely diagnosis, informed choices, and steady medical care.',
    category: 'Diabetes Care',
    department: 'Diabetes & Endocrinology',
    is_featured: true,
    view_count: 4200,
    author: { name: 'Dr. Prabhat Memorial Hiramati Hospital' },
    published_at: '2026-01-20T00:00:00Z',
    featured_image_url: whatIsImg,
    content: `
      <p>Diabetes is a disorder, not a disease - this is something that we reinforce repeatedly. Unfortunately, that does not make it any less dangerous to our health or lives. It is a metabolic disorder, yes, but its consequences are life threatening. A 2014 study estimates that about 62 million people in India are diabetics and the number is projected to rise to 79.4 million by 2030. However, there is respite in the fact that it is a condition that is very much in our control to regularize.</p>
      <h2>What Is Diabetes Mellitus?</h2>
      <p>Our body cells require glucose to function. This is either obtained from the metabolism of food or is produced by the liver and delivered through blood. Insulin is the hormone secreted by the pancreas that allows our cells to absorb glucose. This gives us energy for all voluntary activities like working, playing, exercising, walking or even reading, and involuntary activities such as heart functioning and digestion.</p>
      <p>In diabetes, the glucose does not make it to the cells, thus making them starve for energy. This can be due to very low levels of insulin in the blood or reduced ability of the body to use insulin.</p>
      <p>Constantly elevated levels of blood sugar cause serious complications such as heart attacks, foot disease, kidney disease, eye disease and others.</p>
      <blockquote>When speaking of what is diabetes, we must understand that there are 4 types of diabetes, each having their own course of management. We can successfully manage diabetes only after gathering all the information about diabetes.</blockquote>
      <h2>The Good News</h2>
      <p>The condition becomes easier to understand once glucose movement and insulin function are clear. With timely diagnosis, informed lifestyle choices, and steady medical care, diabetes can usually be managed successfully for many years.</p>
    `,
  },
  {
    id: 'diabetes-2',
    slug: 'types-of-diabetes',
    title: 'Types Of Diabetes: Type 1, Type 2 And Gestational Diabetes Explained',
    excerpt:
      'There are three major types of diabetes, each having a different cause and management strategy. Learn the difference between them and how each is cared for.',
    category: 'Diabetes Care',
    department: 'Diabetes & Endocrinology',
    is_featured: true,
    view_count: 3800,
    author: { name: 'Dr. Prabhat Memorial Hiramati Hospital' },
    published_at: '2026-01-10T00:00:00Z',
    featured_image_url: typesImg,
    content: `
      <p>Diabetes is a chronic condition resulting in high blood sugar levels, because of the impaired glucose regulation in the body. After having food, our digestive system breaks down the food into glucose and other nutrients that are released into blood. Insulin is a key hormone produced by the pancreas and responsible for glucose uptake from the blood to the cells for their functioning.</p>
      <p>Absence of insulin or decreased sensitivity of the body cells to insulin results in diabetes. There are three major types of diabetes, each having a different cause and management strategy.</p>
      <h2>Type 1 Or Insulin-Dependent Diabetes</h2>
      <p>Type 1 diabetes is an important and less prevalent type of diabetes that develops most often at a relatively younger age (children or young adults), and so is also called juvenile diabetes. It is an auto-immune condition where the body's own immune system destroys the insulin producing cells in the pancreas, thus resulting in lack of insulin in the body.</p>
      <p>Management of people with type 1 diabetes requires lifelong insulin supplementation, controlled diet and exercise to help them maintain sugar control.</p>
      <h2>Type 2 Or Non-Insulin Dependent Diabetes</h2>
      <p>Type 2 diabetes is the highly prevalent form of diabetes that affects mostly adults or older age groups. In this specific diabetic condition, the insulin is produced in very low amounts and is insufficient. Both hereditary and lifestyle factors such as poor eating behaviour, sedentary lifestyle, low physical activity, being overweight or obese, play a role in the development of type 2 diabetes.</p>
      <h2>Gestational Diabetes</h2>
      <p>A third type of diabetes, gestational diabetes, is a temporary condition that occurs usually during the second trimester of pregnancy, and disappears after delivery in most cases. Even though temporary, it still requires monitoring and proper medical guidance to protect both mother and baby.</p>
      <p>The type depends on whether the main issue is insulin absence, insulin resistance, or pregnancy-related glucose imbalance.</p>
    `,
  },
  {
    id: 'diabetes-3',
    slug: 'diabetes-symptoms',
    title: 'Diabetes Symptoms: Warning Signs You Should Never Ignore',
    excerpt:
      'Type 1 diabetes often develops quickly, while Type 2 may remain mild and unnoticed for a long time. Knowing the symptoms early can make diagnosis faster and complications less likely.',
    category: 'Diabetes Care',
    department: 'Diabetes & Endocrinology',
    is_featured: false,
    view_count: 2900,
    author: { name: 'Dr. Prabhat Memorial Hiramati Hospital' },
    published_at: '2025-12-28T00:00:00Z',
    featured_image_url: symptomImg,
    content: `
      <h2>Common Symptoms Of Type 1 And Type 2 Diabetes</h2>
      <ul>
        <li>Increased appetite and weight loss because cells can't use glucose and the body feels hungry</li>
        <li>Increased thirst and frequent urination because excess sugar pulls water into urine</li>
        <li>Tiredness, lack of interest and reduced concentration</li>
        <li>Tingling, numbness or pain in hands or feet, especially in Type 2 diabetes</li>
        <li>Blurred vision</li>
        <li>Itching and infections around genital areas</li>
        <li>Slow wound healing</li>
        <li>Muscle weakness and fatigue</li>
      </ul>
      <p>High blood sugar prevents cells from absorbing enough energy, which is why constant hunger may continue even after eating.</p>
      <h2>Diabetes In Children: Remember The 4Ts</h2>
      <p>Children's diabetes is often missed, so these signs should be discussed with a pediatrician without delay.</p>
      <ul>
        <li><strong>Toilet:</strong> Frequent urination, especially at night.</li>
        <li><strong>Thirsty:</strong> Excessive thirst that doesn't improve easily.</li>
        <li><strong>Tired:</strong> Unexplained fatigue and reduced energy.</li>
        <li><strong>Thinner:</strong> Sudden weight loss despite eating.</li>
      </ul>
      <h2>Acute Hyperglycemia And Emergency Symptoms</h2>
      <p>If early symptoms are ignored, blood sugar may rise to dangerous levels and cause emergency symptoms:</p>
      <ul>
        <li>Fruity-smelling breath due to ketoacidosis</li>
        <li>Troubled or rapid breathing</li>
        <li>Increased heart rate and severe weakness</li>
        <li>Severe vomiting and stomach pain</li>
        <li>Altered consciousness, confusion, or seizures</li>
      </ul>
      <blockquote>Immediate medical help is required. Early detection and treatment significantly reduce complications.</blockquote>
    `,
  },
  {
    id: 'diabetes-4',
    slug: 'diabetes-prevention',
    title: 'Diabetes Prevention: Simple Steps To Lower Your Risk',
    excerpt:
      'Did you know that diabetes prevention is often built on simple habits like eating healthy, staying physically active, sleeping well, and reducing excess weight?',
    category: 'Diabetes Care',
    department: 'Diabetes & Endocrinology',
    is_featured: false,
    view_count: 3400,
    author: { name: 'Dr. Prabhat Memorial Hiramati Hospital' },
    published_at: '2025-12-15T00:00:00Z',
    featured_image_url: preventionImg,
    content: `
      <p>Did you know that diabetes prevention is just as simple as eating healthy, being physically active and losing a few extra pounds? Unfortunately, most people get intimidated when it comes to how to control diabetes but as you can see, it's really just a lifestyle change.</p>
      <p>Yes, it surely takes some getting used to but think about all the serious health complications you'll avoid. That includes permanent nerve, kidney and heart damage.</p>
      <p>Type 1 diabetes is the kind of diabetes that cannot be prevented but the impact can be reasonably reduced by managing the person's health well. On the contrary, one's risk for type 2 diabetes could be largely lowered by taking some simple yet important measures, which mainly include modifications to the lifestyle.</p>
      <h2>Easy Steps To Prevent Diabetes</h2>
      <h3>Increase Your Physical Activity</h3>
      <p>This will help you lower the body weight and blood sugar, and makes the body cells, especially muscle cells, more sensitive to insulin. This will help you keep your blood pressure and cholesterol levels under control.</p>
      <h3>Start A Healthy And Balanced Diet</h3>
      <ul>
        <li>Eat a variety of foods and control the portion size instead of excluding a particular food.</li>
        <li>By having fibre rich foods such as fruits, vegetables, whole grains, beans, nuts and seeds, you can not only lower the risk of heart disease, but also control your blood sugar better.</li>
        <li>Take at least half of the total grains as whole grains instead of having more of processed or refined grains, as whole grains are shown to reduce the risk of diabetes.</li>
      </ul>
      <h3>Lose Excess Weight, Regulate Sleep And Quit Smoking</h3>
      <ul>
        <li>Losing excess weight helps maintain blood pressure, brings cholesterol under control, improves mobility and reduces stress and joint damage.</li>
        <li>Sleeping for less than 6 hours can create imbalance between the hormones regulating food intake and energy levels, increasing the risk of diabetes; long sleeping durations for 9 hours or more may also increase risk.</li>
        <li>Smoking can increase abdominal fat deposition and insulin resistance, so quitting is an important measure to decrease your risk for diabetes.</li>
      </ul>
    `,
  },
  {
    id: 'diabetes-5',
    slug: 'diabetes-treatment',
    title: 'Diabetes Treatment: Care And Management That Works',
    excerpt:
      'Care and treatment for diabetes focus on bringing blood sugar close to the normal range using lifestyle measures, medication, and self-monitoring.',
    category: 'Diabetes Care',
    department: 'Diabetes & Endocrinology',
    is_featured: true,
    view_count: 4100,
    author: { name: 'Dr. Prabhat Memorial Hiramati Hospital' },
    published_at: '2025-12-05T00:00:00Z',
    featured_image_url: treatmentImg,
    content: `
      <p>Care and treatment for diabetes focus on bringing blood sugar close to the normal range using lifestyle measures, medication, and self-monitoring. Good control lowers the risk of eye, kidney, nerve, and foot complications.</p>
      <h2>Core Pillars Of Diabetes Care</h2>
      <ul>
        <li><strong>Lifestyle - Diet and Exercise:</strong> Balanced nutrition and portion control, regular physical activity such as 150 minutes per week, and weight management.</li>
        <li><strong>Medication:</strong> Insulin therapy for Type 1 and advanced Type 2 diabetes, oral anti-diabetic drugs, and combination regimens when needed.</li>
        <li><strong>Self-Monitoring Of Glucose:</strong> Daily fingerstick checks or CGM, working toward target HbA1c levels, and preventing hypoglycemia and hyperglycemia.</li>
      </ul>
      <h2>Type 1 Diabetes Treatment</h2>
      <p>Key strategy: External insulin supplementation because the pancreas stops producing insulin. Insulin is a protein that would be degraded by stomach enzymes, so it must be injected subcutaneously.</p>
      <ul>
        <li>Rapid-acting insulin for mealtime coverage</li>
        <li>Short-acting or regular insulin</li>
        <li>Intermediate-acting insulin such as NPH</li>
        <li>Long-acting basal insulin such as glargine or detemir</li>
        <li>Delivery through syringes, insulin pens, or insulin pumps</li>
        <li>Regular glucose monitoring, balanced diet and physical activity with yearly checks for eyes, kidneys, heart, nerves, and dental problems</li>
      </ul>
      <h2>Type 2 Diabetes Treatment</h2>
      <p>For newly diagnosed Type 2 diabetes, treatment focuses on normalizing blood glucose and evaluating complications such as kidney, eye, heart, and nerve disease that may already be present.</p>
      <ul>
        <li>Initial step is lifestyle modification: healthy diet, losing excess weight and regular physical activity.</li>
        <li>Medication escalation if needed: lifestyle plus one anti-diabetic pill such as metformin, then more pills, and finally insulin.</li>
        <li>Check glucose and HbA1c regularly, keep blood pressure and cholesterol in range, and get annual checks for eyes, kidneys, heart, nerves and feet.</li>
      </ul>
      <h2>Gestational Diabetes Treatment</h2>
      <p>Gestational diabetes is successfully managed in most cases by regular physical activity and following nutritional recommendations as advised by the doctor. Some women may require medication such as insulin or oral agents for effective blood sugar control.</p>
      <blockquote>Always consult your healthcare team for an individualized treatment plan. Consistent monitoring, medication adherence, and lifestyle changes are key to preventing long-term complications.</blockquote>
    `,
  },
  {
    id: 'diabetes-6',
    slug: 'type-1-diabetes',
    title: 'Type 1 Diabetes: Causes, Symptoms And Treatment',
    excerpt:
      'Type 1 diabetes is an insulin-dependent autoimmune condition in which the pancreas produces little or no insulin. It often develops in children and young adults.',
    category: 'Diabetes Care',
    department: 'Diabetes & Endocrinology',
    is_featured: false,
    view_count: 2600,
    author: { name: 'Dr. Prabhat Memorial Hiramati Hospital' },
    published_at: '2025-11-22T00:00:00Z',
    featured_image_url: type1Img,
    content: `
      <p>Type 1 diabetes is an insulin-dependent autoimmune condition in which the pancreas produces little or no insulin. It often develops in children and young adults, and symptoms usually appear quickly.</p>
      <h2>What Causes Type 1 Diabetes?</h2>
      <p>Type 1 diabetes occurs when the immune system mistakenly attacks and destroys the insulin-producing beta cells in the pancreas. This autoimmune destruction usually takes years, but symptoms appear quickly. The exact trigger is unknown, but a combination of genetic susceptibility and environmental factors such as viruses, certain bacteria, and cow's milk is thought to play a role.</p>
      <p>Genetic risk: Having a parent or sibling with Type 1 diabetes raises the risk to around 6%, compared to less than 0.5% in the general population.</p>
      <h2>Symptoms Of Type 1 Diabetes</h2>
      <p>Type 1 diabetes develops quickly, over days or weeks, especially in children. Early recognition is critical, as about 25% of people are diagnosed during a life-threatening complication called diabetic ketoacidosis (DKA).</p>
      <ul>
        <li><strong>Thirst:</strong> Excessive thirst even after drinking water; waking at night to drink</li>
        <li><strong>Thinner:</strong> Unexplained weight loss despite eating enough because the body breaks down muscle for energy</li>
        <li><strong>Toilet:</strong> Frequent urination, bedwetting in a previously dry child, waking to urinate at night</li>
        <li><strong>Tired:</strong> Fatigue, lack of energy, difficulty with normal activities</li>
        <li>Feeling very hungry even while eating enough, blurred vision, slow wound healing</li>
      </ul>
      <h2>Treating Type 1 Diabetes</h2>
      <p>The main goal is to keep blood sugar as stable as possible:</p>
      <ul>
        <li>Insulin therapy is essential because the body produces little or no insulin.</li>
        <li>Frequent blood glucose monitoring, often 4 or more times per day.</li>
        <li>Healthy eating and carbohydrate counting to adjust insulin doses.</li>
        <li>Regular exercise, with medical advice on how to adjust insulin for activity.</li>
        <li>Regular check-ups to monitor HbA1c, blood pressure, lipids, kidney function, eyes and feet.</li>
      </ul>
      <blockquote>With proper care, children with type 1 diabetes can lead healthy, active lives and do everything their peers do.</blockquote>
    `,
  },
  {
    id: 'diabetes-7',
    slug: 'type-2-diabetes',
    title: 'Type 2 Diabetes: The Most Common Form And How To Manage It',
    excerpt:
      'Type 2 diabetes is the most common form of diabetes and is strongly linked to insulin resistance. It usually develops slowly over time and may remain unnoticed.',
    category: 'Diabetes Care',
    department: 'Diabetes & Endocrinology',
    is_featured: true,
    view_count: 3600,
    author: { name: 'Dr. Prabhat Memorial Hiramati Hospital' },
    published_at: '2025-11-10T00:00:00Z',
    featured_image_url: type2Img,
    content: `
      <p>Type 2 diabetes occurs when the pancreas cannot produce enough insulin to regulate blood sugar, or the body cannot use insulin effectively (insulin resistance). It develops slowly over years, often without noticeable symptoms.</p>
      <p>Unlike Type 1, Type 2 is most common in middle-aged and older adults, especially those who are overweight or physically inactive. It accounts for 85 to 95% of all diabetes cases.</p>
      <h2>Risk Factors</h2>
      <ul>
        <li><strong>Non-modifiable:</strong> Family history, age especially after 45 years, and ethnicity.</li>
        <li><strong>Modifiable:</strong> Overweight or obesity, physical inactivity, unhealthy diet high in processed foods and sugars, smoking and excessive alcohol intake.</li>
      </ul>
      <h2>Symptoms Of Type 2 Diabetes</h2>
      <ul>
        <li>Increased appetite because cells lack energy despite high blood sugar</li>
        <li>Increased thirst and frequent urination</li>
        <li>Fatigue, headache and irritability</li>
        <li>Unexplained weight loss, itching or infections, slow wound healing, blurred vision</li>
      </ul>
      <p>A unique sign of insulin resistance can be darkened, velvety skin on the neck, armpits, or other body folds. Because symptoms can stay silent, everyone at risk should get tested regularly even if they feel fine.</p>
      <h2>Treating Type 2 Diabetes</h2>
      <p>While Type 2 diabetes cannot be cured, it can be managed effectively to prevent complications:</p>
      <ul>
        <li>Balanced meals with controlled carbohydrates, fiber-rich foods, lean proteins and healthy fats.</li>
        <li>Aim for 150 minutes of moderate exercise such as brisk walking, or 75 minutes of vigorous activity per week, as approved by your doctor.</li>
        <li>Oral anti-diabetic drugs and/or insulin depending on individual needs.</li>
        <li>Regular blood glucose checks help you and your doctor adjust treatment in real time.</li>
      </ul>
      <blockquote>Type 2 diabetes can sometimes be reversed or put into remission with sustained lifestyle changes, especially weight loss and increased physical activity.</blockquote>
    `,
  },
  {
    id: 'diabetes-8',
    slug: 'gestational-diabetes',
    title: 'Gestational Diabetes: What Every Expecting Mother Should Know',
    excerpt:
      'Gestational Diabetes Mellitus is a common glucose disorder during pregnancy. It may improve after delivery, but it still needs close care because it can affect both mother and child.',
    category: 'Diabetes Care',
    department: 'Diabetes & Endocrinology',
    is_featured: false,
    view_count: 2200,
    author: { name: 'Dr. Prabhat Memorial Hiramati Hospital' },
    published_at: '2025-10-28T00:00:00Z',
    featured_image_url: gestationalImg,
    content: `
      <p>Gestational Diabetes Mellitus (GDM) is a condition that occurs during pregnancy when blood glucose levels are higher than normal. Prevalence in India is 3.8% to 21% depending on region and diagnostic methods.</p>
      <p>GDM is associated with an increased risk of developing type 2 diabetes later in life, so it must be managed carefully.</p>
      <h2>Risk Factors For Gestational Diabetes</h2>
      <ul>
        <li>Family history of diabetes and previous history of GDM</li>
        <li>Advanced maternal age (over 35 years)</li>
        <li>Polycystic ovary syndrome (PCOS)</li>
        <li>High birth weight baby or history of macrosomia</li>
        <li>Obesity or overweight during pregnancy</li>
        <li>Hypertension, preeclampsia, smoking or alcohol during pregnancy</li>
      </ul>
      <h2>Prevention And Management</h2>
      <p>Prevention strategies include maintaining a healthy weight before pregnancy, eating a balanced diet, exercising regularly, and avoiding tobacco use.</p>
      <p>Management involves monitoring blood glucose levels throughout pregnancy and adjusting insulin doses as needed to keep them within target ranges.</p>
      <h2>Treatment Options</h2>
      <ul>
        <li><strong>Lifestyle modifications:</strong> Weight management, balanced diet and regular physical activity.</li>
        <li><strong>Medicines:</strong> Oral medications such as metformin can help lower blood glucose levels; insulin therapy is necessary for some women.</li>
      </ul>
      <p>Working with a registered dietitian can help develop a personalized meal plan to manage blood glucose levels and reduce complications.</p>
      <blockquote>Always consult with your healthcare provider or dietitian to tailor dietary choices to your individual needs.</blockquote>
    `,
  },
  {
    id: 'diabetes-9',
    slug: 'diabetes-faqs',
    title: 'Diabetes FAQs: Answers To The Questions People Ask Most',
    excerpt:
      'Only one of three people with diabetes know that they have it, especially because the symptoms develop gradually. Here are clear answers to common concerns.',
    category: 'Diabetes Care',
    department: 'Diabetes & Endocrinology',
    is_featured: false,
    view_count: 3100,
    author: { name: 'Dr. Prabhat Memorial Hiramati Hospital' },
    published_at: '2025-10-12T00:00:00Z',
    featured_image_url: faqImg,
    content: `
      <p>Only one of three people with diabetes know that they have it, especially because the symptoms develop gradually and are hard to identify at first, typically for a person with Type 2 diabetes.</p>
      <h2>What Are The Early Warning Signs Of Diabetes?</h2>
      <p>Common early signs include increased thirst, frequent urination, unexplained fatigue, blurred vision, slow-healing wounds and unusual weight changes. Type 2 diabetes can develop gradually, so symptoms may be mild at first.</p>
      <h2>Can Diabetes Be Controlled With Diet And Exercise Alone?</h2>
      <p>In some people with prediabetes or early Type 2 diabetes, healthy eating, regular exercise and weight management can significantly improve blood sugar control. However, some people still need medicines or insulin depending on their condition.</p>
      <h2>What Is The Difference Between Type 1 And Type 2 Diabetes?</h2>
      <p>Type 1 diabetes happens when the body produces little or no insulin and usually requires lifelong insulin therapy. Type 2 diabetes is more common and often involves insulin resistance, where the body does not use insulin effectively.</p>
      <h2>Who Should Get Tested For Diabetes?</h2>
      <p>People with obesity, a family history of diabetes, high blood pressure, sedentary lifestyle, previous gestational diabetes or symptoms such as excessive thirst and frequent urination should discuss screening with a doctor.</p>
      <h2>Can Diabetes Lead To Other Health Problems?</h2>
      <p>Yes. Uncontrolled diabetes can affect the heart, kidneys, nerves, eyes and feet. Long-term high blood sugar can also increase the risk of infections and slow wound healing.</p>
      <h2>Is Gestational Diabetes Temporary?</h2>
      <p>Gestational diabetes usually develops during pregnancy and often improves after delivery. Even so, it needs proper medical monitoring because it can affect both mother and baby and may increase future diabetes risk.</p>
      <blockquote>Timely questions often lead to timely testing, treatment, and reassurance.</blockquote>
    `,
  },
];

export const getRelatedFallbackBlogs = (currentSlug, limit = 3) =>
  fallbackDiabetesBlogs
    .filter((blog) => blog.slug !== currentSlug)
    .slice(0, limit);